import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'
import { Author } from '../interfaces'

// eslint-disable-next-line import/no-internal-modules
import UserAvatar from '@insided/deprecated-preact-components/User/UserAvatar'

export interface ReportedContent {
  id: string
  reason: string
  reportedAt: string
  reportedBy: Author
}

export interface ReportProps extends ReportedContent {
  key: string
}

const Report = ({ reason, reportedAt, reportedBy }: ReportProps) => {
  const formattedReportedAt = formatDateInLocalTimezone(new Date(reportedAt).getTime() / 1000)
  return (
    <div className='message-in-content message-in-content--reported'>
      <div className='report-metadata'>
        <UserAvatar
          user={{ ...reportedBy, name: reportedBy.username, url: `/member/profile/?userid=${reportedBy.id}` }}
          style={{ width: '20px', height: '20px' }}
          openInNewTab
        />
        <strong>{reportedBy.username}</strong>
        <span className='report-metadata__reported-at'>on {formattedReportedAt}</span>
      </div>
      <div>{reason}</div>
    </div>
  )
}

export default Report
